import { NextRouter } from "next/router";
import { parameterize } from "util/strings";

const onCityChangeLegacy = (
  payload: { city: string; state: string },
  router: NextRouter
) => {
  const { query } = router;
  query.slug = [parameterize(payload.state), parameterize(payload.city)];
  delete query.neighborhoods;
  router.push({
    pathname: router.pathname,
    query,
  });
};

const onNeighborhoodChangeLegacy = (
  newNeighborhoods: {
    parameterizedName: string;
    name: string;
  }[],
  submarkets: {
    neighborhoods: {
      parameterizedName: string;
      name: string;
    }[];
  }[],
  router: NextRouter
) => {
  const { query } = router;
  const submarketNeighorhoods = submarkets.reduce(
    (
      nhoods: {
        parameterizedName: string;
        name: string;
      }[],
      sm
    ): {
      parameterizedName: string;
      name: string;
    }[] => {
      return [...nhoods, ...sm.neighborhoods];
    },
    []
  );
  const neighborhoods = [...newNeighborhoods, ...submarketNeighorhoods];
  // 1->0 neighborhood
  if (
    typeof query.slug === "object" &&
    query.slug.length === 3 &&
    neighborhoods.length === 0
  ) {
    delete query.neighborhoods;
    query.slug.splice(-1);
  }
  // 1 -> 1 different neighborhood
  else if (
    typeof query.slug === "object" &&
    query.slug?.length === 3 &&
    neighborhoods.length === 1 &&
    query.slug[2] !== neighborhoods[0].parameterizedName
  ) {
    query.slug[2] = neighborhoods[0].parameterizedName;
  }
  // multiple -> 0
  else if (neighborhoods.length === 0) {
    delete query.neighborhoods;
  }
  // 2->1 neighborhood
  else if (
    typeof query.neighborhoods === "string" &&
    typeof query.slug === "object" &&
    query.neighborhoods.length > 1 &&
    neighborhoods.length === 1
  ) {
    delete query.neighborhoods;
    query.slug.push(parameterize(neighborhoods[0].name));
  }
  // 0->1 neighborhood
  else if (
    typeof query.slug === "object" &&
    query.slug?.length === 2 &&
    neighborhoods.length === 1
  ) {
    query.slug.push(parameterize(neighborhoods[0].name));
  }
  // 1->2 neighborhood
  else if (
    typeof query.slug === "object" &&
    query.slug.length === 3 &&
    neighborhoods.length > 1
  ) {
    query.slug.splice(-1);
    query.neighborhoods = neighborhoods
      .map((n) => parameterize(n.name))
      .join(",");
  } else {
    query.neighborhoods = neighborhoods
      .map((n) => parameterize(n.name))
      .join(",");
  }
  router.push({
    pathname: router.pathname,
    query,
  });
};

const legacyHandlers = {
  onCityChange: onCityChangeLegacy,
  onNeighborhoodChange: onNeighborhoodChangeLegacy,
};

const uuidHandlers = {
  onLocationChange: (
    areas: { __typename: string; externalId: string; seoString: string }[],
    market: { __typename: string; externalId: string; seoString: string },
    router: NextRouter
  ) => {
    const pathname = "/office-space/m/[...slug]";
    const { query } = router;
    let url = "";

    if (areas.length === 1) {
      url = `${areas[0].seoString}/${areas[0].externalId}`;
      delete query.submarkets;
      delete query.neighborhoods;
    } else if (areas.length > 1) {
      url = `${market.seoString}/${market.externalId}`;
      query.submarkets = areas
        .filter(({ __typename }) => __typename === "Submarket")
        .map(({ externalId }) => externalId)
        .join(",");
      query.neighborhoods = areas
        .filter(({ __typename }) => __typename === "Neighborhood")
        .map(({ externalId }) => externalId)
        .join(",");
    } else {
      url = `${market.seoString}/${market.externalId}`;
      delete query.submarkets;
      delete query.neighborhoods;
    }

    // clean up empties
    if (!query.submarkets?.length) delete query.submarkets;
    if (!query.neighborhoods?.length) delete query.neighborhoods;
    query.slug = url.split("/");
    router.push({
      pathname,
      query,
    });
  },
};

export { legacyHandlers, uuidHandlers };
